import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {contextCheckingStatus, paymentMethod, priceType, promoEditorMode} from '../../constants'

const initialState = {
    processId: 0,

    purchaseStepNumber: 0,
    purchaseStrategyType: '',

    contactFirstName: '',
    contactLastName: '',
    contactMail: '',
    companyInfo: {
        name: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        state: '',
    },

    segment: '',
    newSegment: '',
    lockedSegment: null,
    context: '',
    newContext: '',
    newContextInUse: false,
    newContextInvalid: false,
    contextCheckingStatus: contextCheckingStatus.EMPTY,

    promoEditorMode: promoEditorMode.APPLY,
    promoCode: '',
    promoInvalid: false,
    basePrice: 0,
    totalPrice: 0,
    optionalPrices: [
        // {
        //     amount: null,
        //     description: null,
        //     type: priceType.PROMO_DISCOUNT,
        // },
        // {
        //     amount: null,
        //     description: null,
        //     type: priceType.PAYMENT_METHOD_FEE,
        // },
        // {
        //     amount: null,
        //     description: null,
        //     type: priceType.TAX,
        // },
    ],

    paymentMethod: paymentMethod.CC,
    agreementsConfirmed: false,
    newAgreementsNeeded: false,
    transferHostingZoneProcessing: false,
    vatNumber: '',
    poNumber: '',

    documentUrls: {
        serviceAgreementUrl: null,
        dataProcessingAgreementUrl: null,
        serviceAgreementExhibitUrl: null,
        invoiceUrl: null,
    },
    canPayByWireTransfer: true,
    canPayByCheck: true,

    loading: false,
}

export default handleActions({
    [ActionTypes.PROCESS_ID_SET]: (state, {payload: processId}) => ({
        ...state,
        processId,
    }),
    [ActionTypes.PURCHASE_STEP_NUMBER_SET]: (state, {payload: purchaseStepNumber}) => ({
        ...state,
        purchaseStepNumber,
    }),
    [ActionTypes.PURCHASE_STRATEGY_TYPE_SET]: (state, {payload: purchaseStrategyType}) => ({
        ...state,
        purchaseStrategyType,
    }),
    [ActionTypes.COMPANY_INFO_SET]: (state, {payload: data}) => ({
        ...state,
        companyInfo: {
            ...state.companyInfo,
            ...data,
        },
    }),
    [ActionTypes.INITIAL_HOSTING_ZONE_SET]: (state, {payload: segment}) => ({
        ...state,
        segment,
    }),
    [ActionTypes.HOSTING_ZONE_SET]: (state, {payload: newSegment}) => ({
        ...state,
        newSegment,
    }),
    [ActionTypes.LOCKED_ZONE_SET]: (state, {payload: lockedSegment}) => ({
        ...state,
        lockedSegment,
    }),
    [ActionTypes.CONTEXT_SET]: (state, {payload: newContext}) => ({
        ...state,
        newContext,
        newContextInvalid: false,
    }),
    [ActionTypes.CONTEXT_IN_USE_SET]: (state, {payload: newContextInUse}) => ({
        ...state,
        newContextInUse,
    }),
    [ActionTypes.CONTEXT_INVALID]: (state, {payload: newContextInvalid}) => ({
        ...state,
        newContextInvalid,
    }),
    [ActionTypes.CONTEXT_CHECKING_STATUS_SET]: (state, {payload: contextCheckingStatus}) => ({
        ...state,
        contextCheckingStatus,
    }),
    [ActionTypes.PROMO_EDITOR_MODE_SET]: (state, {payload: promoEditorMode}) => ({
        ...state,
        promoEditorMode,
        promoInvalid: false,
    }),
    [ActionTypes.PROMO_CODE_SET]: (state, {payload: promoCode}) => ({
        ...state,
        promoCode,
    }),
    [ActionTypes.PROMO_INVALID_SET]: (state, {payload: promoInvalid}) => ({
        ...state,
        promoInvalid,
    }),
    [ActionTypes.PRICES_SET]: (state, {payload: data}) => ({
        ...state,
        basePrice: data.variables.basePrice,
        totalPrice: data.variables.totalPrice,
        optionalPrices: [
            {
                amount: data.variables.promoDiscountAmount,
                description: data.variables.promoDiscountShortDescription,
                type: priceType.PROMO_DISCOUNT,
            },
            {
                amount: data.variables.paymentMethodFeeAmount,
                description: data.variables.paymentMethodFeeShortDescription,
                type: priceType.PAYMENT_METHOD_FEE,
            },
            {
                amount: data.variables.taxAmount,
                description: data.variables.taxShortDescription,
                type: priceType.TAX,
            },
        ],
        canPayByWireTransfer: data.variables.canPayByWireTransfer,
        canPayByCheck: data.variables.canPayByCheck,
    }),
    [ActionTypes.PAYMENT_METHOD_SET]: (state, {payload: paymentMethod}) => ({
        ...state,
        paymentMethod
    }),
    [ActionTypes.AGREEMENTS_CONFIRMED_SET]: (state, {payload: agreementsConfirmed}) => ({
        ...state,
        agreementsConfirmed
    }),
    [ActionTypes.TRANSFER_HOSTING_ZONE_PROCESSING_SET]: (state, {payload: transferHostingZoneProcessing}) => ({
        ...state,
        transferHostingZoneProcessing
    }),
    [ActionTypes.DOCUMENT_URLS_SET]: (state, {payload: urls}) => ({
        ...state,
        documentUrls: {
            ...state.documentUrls,
            ...urls
        },
    }),
    [ActionTypes.PURCHASE_INFO_SET]: (state, {payload: info}) => ({ //TODO(enkov): to do
        ...state,
        processId: info.processId,
        completed: info.completed,

        contactFirstName: info.variables.firstName,
        contactLastName: info.variables.lastName,
        contactMail: info.variables.email,

        companyInfo: {
            name: info.variables.company,
            address: info.variables.address,
            city: info.variables.city,
            zip: info.variables.zip,
            country: info.variables.country,
            state: info.variables.state,
        },

        segment: info.variables.segment,
        newSegment: info.variables.newSegment,
        lockedSegment: info.variables.lockedSegment,
        context: info.variables.context,
        newContext: info.variables.newContext,
        newContextInvalid: false,
        newContextInUse: info.variables.newContextInUse,

        basePrice: info.variables.basePrice,
        totalPrice: info.variables.totalPrice,
        optionalPrices: [
            {
                amount: info.variables.promoDiscountAmount,
                description: info.variables.promoDiscountShortDescription,
                type: priceType.PROMO_DISCOUNT,
            },
            {
                amount: info.variables.paymentMethodFeeAmount,
                description: info.variables.paymentMethodFeeShortDescription,
                type: priceType.PAYMENT_METHOD_FEE,
            },
            {
                amount: info.variables.taxAmount,
                description: info.variables.taxShortDescription,
                type: priceType.TAX,
            },
        ],

        paymentMethod: info.variables.paymentMethod,
        newAgreementsNeeded: info.variables.newAgreementsNeeded,
        documentUrls: {
            serviceAgreementUrl: info.variables.serviceAgreementUrl,
            dataProcessingAgreementUrl: info.variables.dataProcessingAgreementUrl,
            serviceAgreementExhibitUrl: info.variables.serviceAgreementExhibitUrl,
            invoiceUrl: info.variables.paidInvoiceUrl || info.variables.proformaInvoiceUrl,
        },

        canPayByWireTransfer: info.variables.canPayByWireTransfer,
        canPayByCheck: info.variables.canPayByCheck,
        vatNumber: info.variables.vatNumber,

        newProductUrl: info.variables.newProductUrl
    }),
    [ActionTypes.PURCHASE_STATE_RESET]: () => ({
        ...initialState
    }),
    [ActionTypes.LOADING_START]: (state) => ({
        ...state,
        loading: true,
    }),
    [ActionTypes.LOADING_FINISH]: (state) => ({
        ...state,
        loading: false,
    }),
    [ActionTypes.VAT_NUMBER_SET]: (state, {payload: vatNumber}) => ({
        ...state,
        vatNumber: vatNumber,
    }),
    [ActionTypes.PO_NUMBER_SET]: (state, {payload: poNumber}) => ({
        ...state,
        poNumber: poNumber,
    }),
}, initialState)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/reducer.js